'use strict'

function open(id) {
    $('#' + id).data('kendoWindow').open();
}

function openCenter(id) {
    $('#' + id).data('kendoWindow').center().open();
}

function close(id) {
    $('#' + id).data('kendoWindow').close();
}

function showWrapper(element) {
    element.siblings('.popup-wrapper').show();
}

function hideWrapper(element) {
    element.siblings('.popup-wrapper').hide();
}

function showError(id, text) {
    $('#' + id).children('.popup__error_text').html(text);
    $('#' + id).show();
}

function hideError(id) {
    $('#' + id).hide();
    $('#' + id).children('.popup__error_text').html('');
}

function openSaveChangesWindow(submitHandler, cancelHandler, message) {
    openCenter('saveChangesWindow');

    $('#saveChangesWindow').find('.popup__content').html(message);

    $('#saveChangesSubmit').unbind('click');
    $('#saveChangesSubmit').on('click', () => {
        close('saveChangesWindow');
        submitHandler();
    });

    $('.popup__savechanges__close').unbind('click');
    $('.popup__savechanges__close').on('click', () => {
        close('saveChangesWindow');
        cancelHandler();
    });
}

module.exports = {
    open: open,
    openCenter: openCenter,
    close: close,
    showWrapper: showWrapper,
    hideWrapper: hideWrapper,
    showError: showError,
    hideError: hideError,
    openSaveChangesWindow: openSaveChangesWindow,
};
